import { render, staticRenderFns } from "./dataManagetable.vue?vue&type=template&id=50694727&scoped=true&"
import script from "./dataManagetable.vue?vue&type=script&lang=js&"
export * from "./dataManagetable.vue?vue&type=script&lang=js&"
import style0 from "./dataManagetable.vue?vue&type=style&index=0&id=50694727&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50694727",
  null
  
)

export default component.exports